<template>
	<v-dialog v-model="reportNotDefinedDialog" max-width="700">
		<v-card>
			<v-card-title class="headline">Formularz sprawozdania końcowego nie jest zdefiniowany</v-card-title>

			<v-card-text>Aby zatwierdzić projekt, należy zdefiniować formularz sprawozdania końcowego.</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="green darken-1"
					flat="flat"
					@click="$emit('close')">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "FinalReportFormNotDefinedDialog",

		props: {
			reportNotDefinedDialog: {},
		},
	};
</script>

<style scoped>

</style>